import { gql } from "apollo-angular";

export const TF = gql`
  fragment TF on TuitionFeeFinder {
    content
    hTag
    header
    aosLabel
    dlLabel
    posLabel
    srLabel
    vrLabel
    pbLabel
    overridesCollection (limit: 5) {
      items {
        alumni
        mil
        milspouse
        indiana
        international
        vet
        stdRate
        name
        id
      }
    }
  }`;
